/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetAttachmentDto } from './GetAttachmentDto';
import {
    GetAttachmentDtoFromJSON,
    GetAttachmentDtoFromJSONTyped,
    GetAttachmentDtoToJSON,
} from './GetAttachmentDto';
import type { GetClientDto } from './GetClientDto';
import {
    GetClientDtoFromJSON,
    GetClientDtoFromJSONTyped,
    GetClientDtoToJSON,
} from './GetClientDto';
import type { GetContractEstimateItemDto } from './GetContractEstimateItemDto';
import {
    GetContractEstimateItemDtoFromJSON,
    GetContractEstimateItemDtoFromJSONTyped,
    GetContractEstimateItemDtoToJSON,
} from './GetContractEstimateItemDto';
import type { GetEmployeeDto } from './GetEmployeeDto';
import {
    GetEmployeeDtoFromJSON,
    GetEmployeeDtoFromJSONTyped,
    GetEmployeeDtoToJSON,
} from './GetEmployeeDto';
import type { GetProjectDto } from './GetProjectDto';
import {
    GetProjectDtoFromJSON,
    GetProjectDtoFromJSONTyped,
    GetProjectDtoToJSON,
} from './GetProjectDto';
import type { SignaturePositionSchemaDto } from './SignaturePositionSchemaDto';
import {
    SignaturePositionSchemaDtoFromJSON,
    SignaturePositionSchemaDtoFromJSONTyped,
    SignaturePositionSchemaDtoToJSON,
} from './SignaturePositionSchemaDto';

/**
 * 
 * @export
 * @interface GetContractExtendedDto
 */
export interface GetContractExtendedDto {
    /**
     * 
     * @type {string}
     * @memberof GetContractExtendedDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetContractExtendedDto
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetContractExtendedDto
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof GetContractExtendedDto
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof GetContractExtendedDto
     */
    status: GetContractExtendedDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetContractExtendedDto
     */
    additionalEmailContent: string;
    /**
     * 
     * @type {string}
     * @memberof GetContractExtendedDto
     */
    emailContent: string;
    /**
     * 
     * @type {string}
     * @memberof GetContractExtendedDto
     */
    emailUid: string;
    /**
     * 
     * @type {string}
     * @memberof GetContractExtendedDto
     */
    emailFrom: string;
    /**
     * 
     * @type {string}
     * @memberof GetContractExtendedDto
     */
    contractorEmail: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetContractExtendedDto
     */
    notSendAutomatically: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetContractExtendedDto
     */
    sentByHand: boolean;
    /**
     * 
     * @type {GetProjectDto}
     * @memberof GetContractExtendedDto
     */
    project: GetProjectDto;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetContractExtendedDto
     */
    responsibleOwner: GetEmployeeDto;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetContractExtendedDto
     */
    authorizedOwner: GetEmployeeDto;
    /**
     * 
     * @type {GetClientDto}
     * @memberof GetContractExtendedDto
     */
    client: GetClientDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetContractExtendedDto
     */
    active: boolean;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetContractExtendedDto
     */
    creator: GetEmployeeDto;
    /**
     * 
     * @type {Date}
     * @memberof GetContractExtendedDto
     */
    creationTs: Date;
    /**
     * 
     * @type {Array<SignaturePositionSchemaDto>}
     * @memberof GetContractExtendedDto
     */
    signaturePositions?: Array<SignaturePositionSchemaDto> | null;
    /**
     * 
     * @type {string}
     * @memberof GetContractExtendedDto
     */
    reasonUnsigning: string;
    /**
     * 
     * @type {Date}
     * @memberof GetContractExtendedDto
     */
    waitingSignDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetContractExtendedDto
     */
    signDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetContractExtendedDto
     */
    unsignDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetContractExtendedDto
     */
    amountUnsettled?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetContractExtendedDto
     */
    signedOutsidePok: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetContractExtendedDto
     */
    tv: boolean;
    /**
     * 
     * @type {GetAttachmentDto}
     * @memberof GetContractExtendedDto
     */
    attachment: GetAttachmentDto;
    /**
     * 
     * @type {Array<GetContractEstimateItemDto>}
     * @memberof GetContractExtendedDto
     */
    contractEstimateItems: Array<GetContractEstimateItemDto>;
}


/**
 * @export
 */
export const GetContractExtendedDtoStatusEnum = {
    Entered: 'Entered',
    WaitingForSigning: 'WaitingForSigning',
    Signed: 'Signed',
    Unsigned: 'Unsigned',
    Sent: 'Sent'
} as const;
export type GetContractExtendedDtoStatusEnum = typeof GetContractExtendedDtoStatusEnum[keyof typeof GetContractExtendedDtoStatusEnum];


/**
 * Check if a given object implements the GetContractExtendedDto interface.
 */
export function instanceOfGetContractExtendedDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "number" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "additionalEmailContent" in value;
    isInstance = isInstance && "emailContent" in value;
    isInstance = isInstance && "emailUid" in value;
    isInstance = isInstance && "emailFrom" in value;
    isInstance = isInstance && "contractorEmail" in value;
    isInstance = isInstance && "notSendAutomatically" in value;
    isInstance = isInstance && "sentByHand" in value;
    isInstance = isInstance && "project" in value;
    isInstance = isInstance && "responsibleOwner" in value;
    isInstance = isInstance && "authorizedOwner" in value;
    isInstance = isInstance && "client" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "creator" in value;
    isInstance = isInstance && "creationTs" in value;
    isInstance = isInstance && "reasonUnsigning" in value;
    isInstance = isInstance && "signedOutsidePok" in value;
    isInstance = isInstance && "tv" in value;
    isInstance = isInstance && "attachment" in value;
    isInstance = isInstance && "contractEstimateItems" in value;

    return isInstance;
}

export function GetContractExtendedDtoFromJSON(json: any): GetContractExtendedDto {
    return GetContractExtendedDtoFromJSONTyped(json, false);
}

export function GetContractExtendedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContractExtendedDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'number': json['number'],
        'amount': json['amount'],
        'status': json['status'],
        'additionalEmailContent': json['additionalEmailContent'],
        'emailContent': json['emailContent'],
        'emailUid': json['emailUid'],
        'emailFrom': json['emailFrom'],
        'contractorEmail': json['contractorEmail'],
        'notSendAutomatically': json['notSendAutomatically'],
        'sentByHand': json['sentByHand'],
        'project': GetProjectDtoFromJSON(json['project']),
        'responsibleOwner': GetEmployeeDtoFromJSON(json['responsibleOwner']),
        'authorizedOwner': GetEmployeeDtoFromJSON(json['authorizedOwner']),
        'client': GetClientDtoFromJSON(json['client']),
        'active': json['active'],
        'creator': GetEmployeeDtoFromJSON(json['creator']),
        'creationTs': (new Date(json['creationTs'])),
        'signaturePositions': !exists(json, 'signaturePositions') ? undefined : (json['signaturePositions'] === null ? null : (json['signaturePositions'] as Array<any>).map(SignaturePositionSchemaDtoFromJSON)),
        'reasonUnsigning': json['reasonUnsigning'],
        'waitingSignDate': !exists(json, 'waitingSignDate') ? undefined : (new Date(json['waitingSignDate'])),
        'signDate': !exists(json, 'signDate') ? undefined : (new Date(json['signDate'])),
        'unsignDate': !exists(json, 'unsignDate') ? undefined : (new Date(json['unsignDate'])),
        'amountUnsettled': !exists(json, 'amountUnsettled') ? undefined : json['amountUnsettled'],
        'signedOutsidePok': json['signedOutsidePok'],
        'tv': json['tv'],
        'attachment': GetAttachmentDtoFromJSON(json['attachment']),
        'contractEstimateItems': ((json['contractEstimateItems'] as Array<any>).map(GetContractEstimateItemDtoFromJSON)),
    };
}

export function GetContractExtendedDtoToJSON(value?: GetContractExtendedDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'systemNumber': value.systemNumber,
        'number': value.number,
        'amount': value.amount,
        'status': value.status,
        'additionalEmailContent': value.additionalEmailContent,
        'emailContent': value.emailContent,
        'emailUid': value.emailUid,
        'emailFrom': value.emailFrom,
        'contractorEmail': value.contractorEmail,
        'notSendAutomatically': value.notSendAutomatically,
        'sentByHand': value.sentByHand,
        'project': GetProjectDtoToJSON(value.project),
        'responsibleOwner': GetEmployeeDtoToJSON(value.responsibleOwner),
        'authorizedOwner': GetEmployeeDtoToJSON(value.authorizedOwner),
        'client': GetClientDtoToJSON(value.client),
        'active': value.active,
        'creator': GetEmployeeDtoToJSON(value.creator),
        'creationTs': (value.creationTs.toISOString()),
        'signaturePositions': value.signaturePositions === undefined ? undefined : (value.signaturePositions === null ? null : (value.signaturePositions as Array<any>).map(SignaturePositionSchemaDtoToJSON)),
        'reasonUnsigning': value.reasonUnsigning,
        'waitingSignDate': value.waitingSignDate === undefined ? undefined : (value.waitingSignDate.toISOString()),
        'signDate': value.signDate === undefined ? undefined : (value.signDate.toISOString()),
        'unsignDate': value.unsignDate === undefined ? undefined : (value.unsignDate.toISOString()),
        'amountUnsettled': value.amountUnsettled,
        'signedOutsidePok': value.signedOutsidePok,
        'tv': value.tv,
        'attachment': GetAttachmentDtoToJSON(value.attachment),
        'contractEstimateItems': ((value.contractEstimateItems as Array<any>).map(GetContractEstimateItemDtoToJSON)),
    };
}

